import { Translation } from './en'
import { getCurrentYear } from '../utils/getCurrentYear'

const year = getCurrentYear()

export const es: Translation = {
  welcome: {
    signIn: 'Iniciar sesión',
    signInText:
      'Revise sus mensajes de texto o correo electrónico para obtener un enlace seguro para acceder a su cuenta.',
    needHelp: '¿Necesita ayuda?',
    contactClinic: 'Póngase en contacto con su equipo de atención. Para obtener asistencia técnica, comuníquese con el ',
    customerSupport: 'equipo de soporte de Navigating Care'
  },
  help: {
    helpTitle: 'Ayuda',
    supportHours: 'Horario de atención al cliente',
    day: 'De lunes a viernes',
    time: '7:00am – 5:00pm (PST)',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    FAQ: 'Preguntas frecuentes',
    question1: '¿Qué es Navigating Care?',
    answer1:
      'Navigating Care es un servicio proporcionado por su clínica que le brinda acceso seguro a su información médica personal desde cualquier teléfono inteligente o dispositivo de navegador web, como una computadora de escritorio o una tableta. Con Navigating Care, ahora tendrá una manera fácil y práctica de mantenerse en contacto con su clínica fuera de sus citas programadas regularmente.',
    question2: '¿Por qué recibí un mensaje de texto o correo electrónico?',
    answer2:
      'Su clínica se ha asociado con Navigating Care para enviarle notificaciones cada vez que se encuentren disponibles nueva información de salud o recursos. Simplemente haga clic en el enlace que aparece en su mensaje de texto o correo electrónico para acceder de manera segura, y ver información personalizada sobre su salud o la atención que recibió de su clínica.',
    question3: '¿Es seguro hacer clic en el enlace del mensaje que recibí?',
    answer3:
      '¡Sí! Cada enlace es completamente seguro y se ha generado exclusivamente para usted. Navigating Care cumple los requisitos contra el correo no deseado de conformidad con la ley CAN-SPAM de EE. UU., lo que significa que nunca recibirá un mensaje a menos que haya aceptado recibir notificaciones de su clínica. ',
    question4:
      '¿Mi información de salud personal (ISP) está segura en Navigating Care?',
    answer4:
      'Su enlace de mensaje y toda la información proporcionada están seguras y protegidas. Navigating Care cumple íntegramente las leyes estatales y la ley federal HIPAA relativas a su privacidad. Para evitar cualquier acceso no autorizado, le solicitamos que verifique su identidad para cada dispositivo en el que utilice Navigating Care, ya sea su teléfono, computadora de escritorio o tableta, antes de poder acceder a su información.',
    question5: '¿El enlace expira?',
    answer5:
      'Sí. Para su seguridad, le pedimos que vuelva a verificar su identidad cada 90 días para cada dispositivo en el que utilice Navigating Care. Una vez que se haya verificado, podrá hacer clic en cualquier enlace que le haya enviado anteriormente para acceder a su información. Sin embargo, si decide salir de Navigating Care, se le pedirá que vuelva a verificar su identidad la próxima vez que intente consultar su información.',
    question6:
      '¿Qué debo hacer si mi información de salud personal es incorrecta?',
    answer6:
      'Navigating Care recibe su información de salud personal directamente del registro médico electrónico de su clínica. Si cree que hay un error, comuníquese directamente con su consultorio para actualizar su información.',
    question7: '¿Hay una tarifa para utilizar el servicio?',
    answer7:
      'No, Navigating Care es un servicio gratuito que brinda su clínica para ayudarlo a administrar mejor su atención. Sin embargo, es posible que se apliquen tarifas de mensajes de texto estándar si elige recibir mensajes a través de su dispositivo móvil.',
    question8:
      '¿Con quién me debo ponerme en contacto para obtener asistencia técnica?',
    answer8: {
      answer:
        'Para obtener asistencia técnica con Navigating Care, comuníquese con el equipo de soporte de Navigating Care en ',
      orCall: 'o llame',
      time:
        'de lunes a viernes, de 7:00 a. m. a 5:00 p. m., zona horaria del Pacífico. ¡Haremos todo lo que podamos para ayudarlo!'
    }
  },
  acceptTerms: {
    title: 'Ya casi está',
    reviewMessageTitle:
      'Revise la siguiente información sobre cómo recibir mensajes de {{clinicName}}.',
    chooseReceiveText:
      'Si elige recibir mensajes de texto de Navigating Care, es posible que se apliquen tarifas estándar de mensajes y datos. La frecuencia de mensajes puede variar. Para obtener ayuda, envíe un mensaje de texto con la palabra HELP al 82790 o visite',
    moreInformation: 'Para obtener más información, consulte nuestra',
    privacyPolicy: 'Política de privacidad',
    orSee: 'o consulte',
    FAQ: 'las Preguntas frecuentes',
    texingStop:
      'Puede optar por no recibir mensajes de texto enviando el mensaje de texto STOP al 82790.',
    acceptingNC:
      'Al hacer clic en Continuar, está aceptando las Condiciones de uso de Navigating Care.',
    termsOfUse: 'Términos de Uso',
    continue: 'Continuar',
    decline: 'No acepto'
  },
  patientConsent: {
    agree: 'Sí estoy de acuerdo',
    decline: 'renuncio'
  },
  confirmSignOut: {
    title: '¿Está seguro de que desea cerrar sesión?',
    subTitle:
      'Una vez que se haya desconectado, deberá verificar su identidad nuevamente para ver los mensajes de su clínica.',
    staySignIn: 'Seguir conectado.',
    signOut: 'Cerrar sesión'
  },
  editPreferences: {
    title: 'Preferencias',
    mobileNo: 'Número de teléfono móvil',
    emailAddress: 'Correo electrónico',
    save: 'Guardar',
    cancel: 'Cancelar'
  },
  listMessages: {
    title: 'Mensajes'
  },
  start: {
    helthInformation: 'Su información de salud proporcionada por',
    welcome: 'Bienvenido',
    verifyInformation:
      'Verifique su información para acceder a los mensajes de su clínica.',
    start: 'Inicio',
    privacyInformation:
      'Su privacidad es importante para nosotros. Para obtener más información, consulte nuestras',
    termsOfUse: 'Condiciones de uso',
    and: 'y ',
    privactPolicy: 'Política de privacidad'
  },
  termsDeclined: {
    thankYou: 'Gracias',
    subTitle:
      'Ya no enviaremos alertas sobre este mensaje. Si decide que desea acceder a su mensaje, aún puede aceptar los términos ahora o llamar a nuestro equipo de soporte.',
    backToTerm: 'Volver a Términos',
    sincerely: 'Sinceramente,',
    yourCare: 'Su equipo de atención en'
  },
  tooManyLoginAttempts: {
    oops: 'Demasiados intentos de verificación',
    errorMessage:
      'Hemos bloqueado temporalmente el acceso a este servicio por su seguridad. Por favor vuelva a intentarlo en 30 minutos.',
    contactClinic: "Comuníquese con su clínica o programa de apoyo para obtener ayuda para iniciar sesión.",
    mainPhone: "Teléfono de la oficina principal",
    nc: 'Navigating Care',
    customerSupport: 'Horario de atención al cliente',
    day: 'De lunes a viernes',
    time: '7:00am - 5:00pm (PST)',
    email: 'Correo electrónico',
    phone: 'Teléfono'
  },
  verify: {
    verifyPatientInformation: 'Verificar la información del paciente',
    verifyBirthdate: "Verifique la fecha de nacimiento del paciente para comenzar",
    firstName: 'Nombre',
    lastName: 'Apellido',
    DOB: 'Fecha de nacimiento',
    invalidDob: 'La fecha de nacimiento debe ser una fecha válida.',
    month: 'Mes',
    day: "Día",
    year: "Año",
    yearPlaceholder: "AAAA",
    zipCode: 'Código postal',
    validationMessage: 'Ingrese su código postal de 5 dígitos.',
    verify: 'Verifique',
    errorTitle: 'Oops! Algo no coincidió',
    errorMessage:
      'Después de cinco intentos, se bloqueará el acceso a este servicio. Para obtener ayuda, <0>comuníquese con su clínica</0>.',
    aboutTitle: 'Acerca de Navigating Care',
    aboutDescription: "Su clínica utiliza Navigating Care para brindarle servicios que le ayuden a mantenerse conectado con su equipo de atención.",
    privacyPolicy: "Su privacidad es muy importante para nosotros. Para mayor información, revise nuestros <0>condiciones de uso</0> y <1>política de privacidad</1>.",
    dobRequired: "Se requiere la fecha de nacimiento.",
    yearDigits: "El año debe tener cuatro dígitos.",
    digitalCompanion: "Su compañero de salud digital para",
    rememberMe: "Recuérdeme en este dispositivo por 60 días. Desmarque si está en un dispositivo público."
  },
  viewMessages: {
    successMessage:
      '¡Conseguido! Ya está listo para ver los mensajes de {{clinicName}}.',
    messages: 'Mensajes',
    backToTop: 'Volver al principio'
  },
  viewPreferences: {
    title: 'Preferencias',
    mobileNo: 'Número de teléfono móvil',
    emailAddress: 'Correo electrónico',
    edit: 'Editar'
  },
  yourClinic: {
    title: 'Su clínica',
    viewOnMap: 'Vista en el mapa',
    phone: 'Teléfono'
  },
  about: {
    title: 'Sobre nosotros',
    detail:
      'Navigating Care entrega mensajes de su clínica y otros recursos para ayudarlo con su atención médica.'
  },
  errorMessage: {
    title: 'Huy! Algo salió mal',
    error:
      'Lo sentimos, pero esta página no está disponible en este momento. Por favor, inténtelo de nuevo más tarde.',
    errorCode: 'Código de error {{code}}'
  },
  footer: {
    about: 'Acerca de',
    help: 'Ayuda',
    termsOfUse: 'Condiciones de uso',
    privacyPolicy: 'Política de privacidad',
    englishSelect: 'Inglés',
    spanishSelect: 'Español'
  },
  layoutWrapper: {
    messages: 'Mensajes',
    yourClinic: 'Su clínica',
    preferences: 'Preferencias',
    signOut: 'Cerrar sesión',
    help: 'Ayuda'
  },
  common: {
    nc: 'Navigating Care',
    copy: `© ${year} Navigating Care, Inc`,
    url: '',
    phone: '1-800-925-4456',
    supportEmail: 'support@navigatingcare.com',
    infoEmail: 'info@navigatingcancer.com'
  }
}
